var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkOutline2 = function SvgCheckmarkOutline2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "nonzero",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FBD14",
    d: "M7.983 1.333C4.31 1.333 1.331 4.318 1.331 8s2.978 6.667 6.652 6.667S14.636 11.682 14.636 8a6.672 6.672 0 0 0-1.949-4.714 6.646 6.646 0 0 0-4.704-1.953z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.78 5.593 7.264 8.927 6.18 7.52a.666.666 0 1 0-1.051.82l1.617 2.073a.664.664 0 0 0 1.051-.006l3.04-4a.671.671 0 0 0-.126-.94.668.668 0 0 0-.938.126h.006z"
  }))));
};

export default SvgCheckmarkOutline2;